import React, { useState } from "react";
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HeadingDropdowns, Href, Party } from "../../../../Constant";
import { HEADING_DATA } from "../../../../Data/UiKit/Typography";

const HeadingDropdown = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <Col xl="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={HeadingDropdowns} span={HEADING_DATA} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <div className="btn-group">
              <Dropdown isOpen={open} toggle={toggle}>
                <DropdownToggle caret color="primary" className="dropbtn">{Party}</DropdownToggle>
                <DropdownMenu className="dropdown-block">
                  <DropdownItem header className="border-bottom border-2 fw-bold fs-6 opacity-75">Party List</DropdownItem>
                  <DropdownItem href={Href}>Balloons</DropdownItem>
                  <DropdownItem href={Href}>Cake</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default HeadingDropdown;
